import { render } from "./AdvisorList.vue?vue&type=template&id=0b76f75c"
import script from "./AdvisorList.vue?vue&type=script&lang=js"
export * from "./AdvisorList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__